import React from 'react';
import { graphql } from 'react-apollo';

import Loader from './Loader';

const ErrorView = ({ refetch }) => (
  <span>
    Something went wrong, you can try to
    <button type="button" onClick={() => refetch && refetch()}>
      refetch
    </button>
  </span>
);

/**
 * GraphQL query HOC with loading / error UI.
 * Implemented without recompose to avoid React.createFactory() deprecation (React 18).
 */
const withGraphqlData = (query, propsToVariables = null, fetchPolicy = 'cache-first') =>
  (WrappedComponent) => {
    const Inner = (props) => {
      const { data } = props;

      if (!data || data.loading) {
        return <Loader />;
      }
      if (data.error) {
        return <ErrorView refetch={data.refetch} />;
      }

      return <WrappedComponent {...props} refetch={data.refetch} />;
    };

    Inner.displayName = `WithGraphqlData(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return graphql(query, {
      options: (props) => ({
        variables: propsToVariables && propsToVariables(props),
        fetchPolicy,
      }),
    })(Inner);
  };

export default withGraphqlData;
